<div class="wrapper pt-4">
  <div class="page-wrapper">
    <div class="page-content pt-0 pe-xl-0 ps-xl-0 pe-2 ps-2">
      <div class="row">
        <div class="col-xl-12">
          <div class="">
            <h4 class="dashboard-title">Dashboard</h4>
            <p class="text-muted">
              Welcome back! Here's an overview of your instructing activities.
            </p>

            <!-- Stats Section -->

            <div class="row">
              <div class="col-xl-8">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <div class="stat-card h-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="stat-title">Credit Transfer</h6>
                        <!-- <i class="bi bi-eye text-muted"></i> -->
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="stat-number">
                          {{ creditTransferCount?.pendingcount }}
                        </div>
                        <div class="stat-total">
                          Total: {{ creditTransferCount?.totalcount }}
                        </div>
                      </div>
                      <p class="stat-desc">
                        Pending credit transfers applications
                      </p>

                      <div class="stat-footer">
                        <div class="growth-tag">
                          {{ creditTransferCount?.percentage1 }}
                        </div>
                        <div class="icon-group1">
                          <i class="bi bi-download"></i>
                          <i class="bi bi-eye"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Exemptions -->
                  <div class="col-md-4">
                    <div class="stat-card h-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="stat-title">Exemptions</h6>
                        <!-- <i class="bi bi-eye text-muted"></i> -->
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="stat-number">
                          {{ exemptionCount?.pendingcount }}
                        </div>
                        <div class="stat-total">
                          Total: {{ exemptionCount?.totalcount }}
                        </div>
                      </div>
                      <p class="stat-desc">Pending exemptions applications</p>

                      <div class="stat-footer">
                        <div class="growth-tag">
                          {{ exemptionCount?.percentage1 }}
                        </div>
                        <div class="icon-group1">
                          <i class="bi bi-download"></i>
                          <i class="bi bi-eye"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Assigned Courses -->
                  <div class="col-md-4">
                    <div class="stat-card h-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="stat-title">Assigned Courses</h6>
                        <!-- <i class="bi bi-eye text-muted"></i> -->
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="stat-number">
                          {{ assignedCourses?.pendingcount }}
                        </div>
                        <div class="stat-total">
                          Total: {{ assignedCourses?.totalcount }}
                        </div>
                      </div>
                      <p class="stat-desc">Current assigned courses</p>

                      <div class="stat-footer">
                        <div class="growth-tag bg-light text-dark border">
                          {{ assignedCourses?.percentage1 }}
                        </div>
                        <div class="icon-group1">
                          <i class="bi bi-download"></i>
                          <i class="bi bi-eye"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Alerts -->
                  <div class="mb-4 mt-4">
                    <div class="col-xl-12">
                      <div style="height: 100px !important" class="alerts-box p-3 rounded-3 border border-danger">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <h6 class="fw-semibold mb-0">Alerts</h6>
                          <i class="bi bi-exclamation-circle text-danger"></i>
                        </div>

                        <div class="d-flex gap-3 flex-wrap">
                          <!-- <div class="alert-item alert-deadline flex-fill">
                              <strong>Deadline Alert</strong><br />
                              <span>Marks submission is due in 2 days</span>
                            </div> -->

                          <!-- <div class="alert-item alert-followup flex-fill">
                              <strong>Follow-Up Required</strong><br />
                              <span
                                >Credit transfers required your attention</span
                              >
                            </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Right Side -->
              <div class="col-md-4">
                <div class="quick-actions mb-3 p-3 rounded-3">
                  <h6 class="text-white fw-semibold mb-3">Quick Actions</h6>

                  <div class="quick-action-item mb-2 p-3 rounded-2" role="button" style="cursor: pointer" [routerLink]="[
                        '/OneApp',
                        'Assessment',
                        'courseWiseMarksCapture',
                        '5069'
                      ]">
                    <div class="d-flex justify-content-between align-items-center text-white">
                      <div>
                        <div class="fw-semibold">Marks Capture</div>
                        <small class="text-white-50">Submit new marks for your courses</small>
                      </div>
                      <i class="bi bi-chevron-right fs-5 text-white"></i>
                    </div>
                  </div>

                  <div class="quick-action-item mb-2 p-3 rounded-2" role="button" style="cursor: pointer"
                    [routerLink]="['/OneApp/Assessment/scoreAnalysisRprt/4992']">
                    <div class="d-flex justify-content-between align-items-center text-white">
                      <div>
                        <div class="fw-semibold">Class Score Analysis</div>
                        <small class="text-white-50">Get individual marksheets</small>
                      </div>
                      <i class="bi bi-chevron-right fs-5 text-white"></i>
                    </div>
                  </div>

                  <a class="quick-action-item p-3 rounded-2 text-decoration-none d-block" target="_blank"
                    rel="noopener noreferrer" (click)="openInNewTab()">
                    <div class="d-flex justify-content-between align-items-center text-white">
                      <div>
                        <div class="fw-semibold">SOMAS</div>
                        <small class="text-white-50">
                          Access your LMS instructing account
                        </small>
                      </div>
                      <i class="bi bi-chevron-right fs-5 text-white"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-7">
                <div class="row g-3 mb-3">
                  <div style="height: 300px !important" class="card recent-activities-card p-3 mb-3 border-0 shadow-sm">
                    <h6 class="fw-semibold mb-3">Recent Activities</h6>
                    <div class="d-none">
                      <div class="activity-item d-flex justify-content-between align-items-start py-2">
                        <div class="d-flex align-items-start">
                          <span class="dot bg-success me-2 mt-1"></span>
                          <div>
                            <div class="fw-semibold text-dark">
                              Marks submitted
                            </div>
                            <small class="text-secondary">PLA 712</small>
                          </div>
                        </div>
                        <small class="text-muted">2 hours ago</small>
                      </div>
                      <hr class="my-1" />

                      <div class="activity-item d-flex justify-content-between align-items-start py-2">
                        <div class="d-flex align-items-start">
                          <span class="dot bg-primary me-2 mt-1"></span>
                          <div>
                            <div class="fw-semibold text-dark">
                              Credit transfer approved
                            </div>
                            <small class="text-secondary">KAMAU, Joseph Njeri</small>
                          </div>
                        </div>
                        <small class="text-muted">5 hours ago</small>
                      </div>
                      <hr class="my-1" />

                      <div class="activity-item d-flex justify-content-between align-items-start py-2">
                        <div class="d-flex align-items-start">
                          <span class="dot bg-primary me-2 mt-1"></span>
                          <div>
                            <div class="fw-semibold text-dark">
                              Credit transfer approved
                            </div>
                            <small class="text-secondary">KAMAU, Joseph Njeri</small>
                          </div>
                        </div>
                        <small class="text-muted">1 day ago</small>
                      </div>
                      <hr class="my-1" />

                      <div class="activity-item d-flex justify-content-between align-items-start py-2">
                        <div class="d-flex align-items-start">
                          <span class="dot bg-info me-2 mt-1"></span>
                          <div>
                            <div class="fw-semibold text-dark">
                              Marks Captured
                            </div>
                            <small class="text-secondary">PLA 720</small>
                          </div>
                        </div>
                        <small class="text-muted">Sept 21, 2025</small>
                      </div>
                      <hr class="my-1" />

                      <div class="activity-item d-flex justify-content-between align-items-start py-2">
                        <div class="d-flex align-items-start">
                          <span class="dot bg-primary me-2 mt-1"></span>
                          <div>
                            <div class="fw-semibold text-dark">
                              Credit transfer approved
                            </div>
                            <small class="text-secondary">KAMAU, Joseph Njeri</small>
                          </div>
                        </div>
                        <small class="text-muted">Sept 21, 2025</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Right Side -->
              <div class="col-md-5">
                <!-- Captured Marks -->

                <div class="dashboard-right-col">
                  <!-- Captured Marks -->
                  <div class="marks-card">
                    <h6>Captured Marks</h6>

                    <!-- Course 1 -->
                    <div class="marks-section" *ngFor="let item of CapturedMarks">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <p class="mb-0">{{ item.subject_name }}</p>
                        <small>
                          {{ item.marks_count }}/{{ item.total_users }}
                          Students
                        </small>
                      </div>

                      <div class="progress mb-2">
                        <div class="progress-bar" role="progressbar" [style.width.%]="getProgress(item)"
                          [attr.aria-valuenow]="getProgress(item)" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>

                  <!-- Students by Programme -->
                  <div class="programme-card">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">Students by Programme</h6>
                      <select (change)="
                            getGetStudentsByProgramme($event.target.value)
                          " class="form-select form-select-sm w-auto">
                        <option *ngFor="let item of CapturedMarks" [value]="item.subject_id">
                          {{ item.subject_name?.split(" - ")[0] }}
                        </option>
                      </select>
                    </div>

                    <!-- Programme 1 -->
                    <div class="students-section" *ngFor="let item of StudentsByProgramme | slice : 0 : 3">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <p class="mb-0">{{ item.course_name }}</p>
                        <small>{{ item.registered_count }}/{{
                          item.total_count
                          }}
                          Students</small>
                      </div>
                      <div class="progress mb-2">
                        <div class="progress-bar" role="progressbar" [style.width.%]="getProgressByProgram(item)"
                          [attr.aria-valuenow]="getProgressByProgram(item)" aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                    </div>
                    <div *ngIf="StudentsByProgramme?.length > 3" class="text-end mt-2">
                      <button class="btn btn-link text-primary p-0" (click)="openProgrammeModal()">
                        View More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl=5"></div>
              <div class="col-xl-7"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="programmeModal" tabindex="-1" aria-labelledby="programmeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="programmeModalLabel">All Programmes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="students-section" *ngFor="let item of StudentsByProgramme">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <p class="mb-0">{{ item.course_name }}</p>
            <small>{{ item.registered_count }}/{{
              item.total_count
              }}
              Students</small>
          </div>
          <div class="progress mb-2">
            <div class="progress-bar" role="progressbar" [style.width.%]="getProgressByProgram(item)"
              [attr.aria-valuenow]="getProgressByProgram(item)" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>